import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { StringAdapter } from "../StringAdapter";
import { TranslateService } from "@ngx-translate/core";

export class FixingSourceAdapter extends StringAdapter {
  private STR_DASH: string = "-";

  constructor(private _translate: TranslateService) {
    super();
  }

  retrieveData(order: any, columnProperty: string): string {
    let val = order[columnProperty];
    if (val != null && typeof val === "string") {
      return val;
    }

    if (
      CubiqTS.Product.NDF === order["product"] /* order */ ||
      "NDF" === order["productType"] /* deal */
    ) {
      let desc: string = this._translate.instant("fixingSource.custom");
      return desc;
    }

    return this.STR_DASH;
  }
}
